export function safeJsonParse(string: string, defaultValue?: any) {
  try {
    return JSON.parse(string);
  } catch {
    return defaultValue;
  }
}
